const DEVICE_ID_KEY = 'resolva_device_id';

export function getOrCreateDeviceId(): string {
  if (typeof window === 'undefined') return 'server'; // SSR guard

  let deviceId = localStorage.getItem(DEVICE_ID_KEY);

  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }

  return deviceId;
}
